import { render } from "./DangerZonePage.vue?vue&type=template&id=644d62a8&scoped=true"
import script from "./DangerZonePage.vue?vue&type=script&lang=js"
export * from "./DangerZonePage.vue?vue&type=script&lang=js"

import "./DangerZonePage.vue?vue&type=style&index=0&id=644d62a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644d62a8"]])

export default __exports__